var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrowBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_345_2788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00293 13.5312C5.00293 13.0825 5.3667 12.7188 5.81543 12.7188H20.9821C21.4308 12.7188 21.7946 13.0825 21.7946 13.5312C21.7946 13.98 21.4308 14.3438 20.9821 14.3438H5.81543C5.3667 14.3438 5.00293 13.98 5.00293 13.5312Z",
    fill: "#3E3E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.89 7.60577C13.2073 7.28847 13.2073 6.77403 12.89 6.45673C12.5727 6.13942 12.0582 6.13942 11.7409 6.45673L5.24117 12.9565C5.24108 12.9565 5.24099 12.9566 5.24091 12.9567C4.9236 13.274 4.9236 13.7885 5.24091 14.1058C5.24103 14.1059 5.24116 14.106 5.24128 14.1061L11.7409 20.6058C12.0582 20.9231 12.5727 20.9231 12.89 20.6058C13.2073 20.2885 13.2073 19.774 12.89 19.4567L6.96448 13.5312L12.89 7.60577Z",
    fill: "#3E3E4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345_2788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.398438 0.53125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowBlackIcon);
export default __webpack_public_path__ + "static/media/back-arrow-black-icon.204cd22a684210d6f6cf0be019dc9cc8.svg";
export { ForwardRef as ReactComponent };